import { useId } from "react";

export const DiscoLogo = ({ size = 32 }) => {
  const uid = useId().replace(/:/g, "");
  return (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-label="Glimpse" data-testid="glimpse-logo">
    <defs>
      <radialGradient id={`dg${uid}`} cx="35%" cy="30%" r="75%">
        <stop offset="0%" stopColor="#FFE4F1" />
        <stop offset="45%" stopColor="#FF52A3" />
        <stop offset="100%" stopColor="#8A0F4D" />
      </radialGradient>
      <clipPath id={`dc${uid}`}><circle cx="32" cy="34" r="24" /></clipPath>
    </defs>
    <line x1="32" y1="2" x2="32" y2="10" stroke="#B3B3B3" strokeWidth="2" />
    <circle cx="32" cy="34" r="24" fill={`url(#dg${uid})`} />
    <g clipPath={`url(#dc${uid})`} stroke="#5c0a33" strokeOpacity="0.55" strokeWidth="1.2" fill="none">
      {[16, 22, 28, 34, 40, 46, 52].map((y) => <line key={`h${y}`} x1="6" y1={y} x2="58" y2={y} />)}
      {[14, 20, 26, 32, 38, 44, 50].map((x) => <ellipse key={`v${x}`} cx="32" cy="34" rx={Math.abs(32 - x) + 0.5} ry="24" />)}
    </g>
    <rect x="20" y="22" width="5" height="5" fill="#fff" opacity="0.9" />
    <rect x="27" y="17" width="4" height="4" fill="#fff" opacity="0.6" />
    <path d="M52 8l1.5 3.5L57 13l-3.5 1.5L52 18l-1.5-3.5L47 13l3.5-1.5z" fill="#fff" />
  </svg>
  );
};
